import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import SubstanceProperty from '@Components/Results/substances/SubstanceProperty';

function SubstanceReaxysInformation({ metadata, substance, details, database, substanceIndex, facts, toggle, zoom }) {
  return (
    <ul className="rx-accordion medium">
      {map(
        facts,
        (fact, id) =>
          !fact.hitData && (
            <SubstanceProperty
              key={id}
              metadata={metadata}
              substance={substance}
              fact={fact}
              details={details}
              database={database}
              substanceIndex={substanceIndex}
              toggle={toggle}
              open={fact.isOpen}
              zoom={zoom}
            />
          )
      )}
    </ul>
  );
}

SubstanceReaxysInformation.propTypes = {
  metadata: MetadataPropTypesShape,
  substance: PropTypes.object.isRequired,
  details: PropTypes.object.isRequired,
  database: PropTypes.object.isRequired,
  substanceIndex: PropTypes.string.isRequired,
  facts: PropTypes.object,
  toggle: PropTypes.func,
  zoom: PropTypes.number,
};

export default SubstanceReaxysInformation;
